import {
  QuestionMultipleValueExceptionConfig,
  StatusBaseConfig,
  StatusConfig,
} from '@gripp/shared-logic';
import { Colors } from 'libs/shared-ui/src/themes';
import { Control } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { StyleSheet, View } from 'react-native';
import { array, boolean, string } from 'yup';
import { ControlledCheckboxItem } from '../../forms';
import { ControlledTextArrayInput } from '../../forms/controlledTextArrayInput';
import { RoutineAdminForm, RoutineAdminFormProps } from '../types';

export const StatusAdminSchema = {
  statuses: array()
    .of(string())
    .when('openEndedResponse', {
      is: true,
      then: (schema) => schema.min(0),
      otherwise: (schema) => schema.min(1),
    }),
  openEndedResponse: boolean().optional(),
};

export const StatusAdminForm: RoutineAdminForm<StatusConfig> = (
  props: RoutineAdminFormProps<StatusConfig>
) => {
  return <StatusAdminComponent config={props.config} control={props.control} />;
};

type StatusConfigAdminComponentProps = {
  config: StatusBaseConfig;
  control: Control;
  indexPrefix?: string;
  showResponseExceptions?: boolean;
};

export const StatusAdminComponent = (
  props: StatusConfigAdminComponentProps
) => {
  const { t } = useTranslation();
  const i18nPrefix = 'routines.status.admin.openEndedResponse';

  const fieldName = props.indexPrefix
    ? `${props.indexPrefix}.statuses`
    : 'statuses';

  const openEndedResponseFieldName = props.indexPrefix
    ? `${props.indexPrefix}.openEndedResponse`
    : 'openEndedResponse';

  props.control.register(openEndedResponseFieldName, {
    value: props.config.openEndedResponse ?? false,
  });

  return (
    <>
      <ControlledTextArrayInput
        label={t('routines.status.admin.statuses')}
        addMoreLabel={t('routines.status.admin.addStatus')}
        name={fieldName}
        control={props.control}
        defaultValues={props.config.statuses}
        showResponseExceptions={props.showResponseExceptions}
        exceptionsPrefix={props.indexPrefix}
        defaultExceptionValues={
          props.showResponseExceptions
            ? (props.config as QuestionMultipleValueExceptionConfig)
                .responseExceptions ?? []
            : undefined
        }
      />
      <View style={styles.checkboxContainer}>
        <ControlledCheckboxItem
          control={props.control}
          name={openEndedResponseFieldName}
          label={t(`${i18nPrefix}`)}
          labelStyle={styles.label}
          position="trailing"
        />
      </View>
    </>
  );
};

const styles = StyleSheet.create({
  checkboxContainer: {
    alignItems: 'flex-start',
    marginHorizontal: 10,
  },
  label: {
    fontSize: 16,
    lineHeight: 16,
    color: Colors.black,
    fontWeight: '700',
  },
});
